export default __webpack_public_path__ + "static/media/SWT0100.34I-18700_-14554_0.0678a260.jpg";